module.exports = __webpack_public_path__ + "img/StaffStyle2.d2dc430a.jpg";